import { INBOX_URL } from "./constants";

export function constructFullUrl(contactUrl: string): string{
    return (contactUrl.startsWith('/') ? `${window.location.protocol}//${window.location.host}${contactUrl}` : contactUrl);
}

export function redirectToInbox() {
    if (typeof window === 'undefined') {
        return;
    }

    window.location.href = INBOX_URL;
}

export function addQueryParamNoRefresh(key: string, value: string) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.pushState({}, '', url.toString());
}

export function removeQueryParam(key: string, path: string): string {
    const url = new URL(path);
    url.searchParams.delete(key);
    return url.toString();
}

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));